import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, Trash2, Users } from 'lucide-react';
import { Button } from '../../components/ui/button';
import api, { resolveMedia } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

export default function AdminAgents() {
  const [items, setItems] = useState([]);
  const { toast } = useToast();
  const load = () => api.get('/admin/agents').then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this advisor?')) return;
    await api.delete('/admin/agents/' + id);
    toast({ title: 'Deleted' });
    load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold text-neutral-900">Advisors</h1><p className="text-sm text-neutral-500">{items.length} advisors</p></div>
        <Link to="/admin/agents/new"><Button className="btn-primary gap-2"><Plus className="w-4 h-4" /> New Advisor</Button></Link>
      </div>
      {items.length === 0 ? (
        <div className="bg-white p-12 rounded-xl border border-neutral-200 text-center">
          <Users className="w-10 h-10 text-neutral-300 mx-auto mb-2" />
          <p className="text-neutral-500">No advisors yet</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((a) => (
            <div key={a.id} className="bg-white p-5 rounded-xl border border-neutral-200">
              <div className="flex items-center gap-4">
                <img src={resolveMedia(a.photo) || '/assets/logo.png'} alt={a.name} className="w-16 h-16 rounded-full object-cover bg-neutral-100" />
                <div className="flex-1">
                  <p className="font-bold text-neutral-900">{a.name}</p>
                  <p className="text-xs text-[#DC2626]">{a.title}</p>
                  <p className="text-xs text-neutral-500">{a.email}</p>
                </div>
              </div>
              <p className="mt-3 text-sm text-neutral-600 line-clamp-2">{a.bio}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-neutral-500">Rating: {a.rating} · Sold: {a.sold}</span>
                <div className="flex gap-1">
                  <Link to={'/admin/agents/' + a.id}><Button size="sm" variant="outline" className="gap-1"><Edit className="w-3.5 h-3.5" /></Button></Link>
                  <Button size="sm" variant="outline" onClick={() => remove(a.id)} className="gap-1 text-red-600 border-red-200"><Trash2 className="w-3.5 h-3.5" /></Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
